import CryptoJS from 'crypto-js';

const aesKey = 'M&AGateway';

const setSessionStorage = (key, value) => {
  // console.log('key1: ', key, value);
  if (typeof value === 'string') {
    const cryptoInfo = CryptoJS.AES.encrypt(
      JSON.stringify({ value }),
      aesKey,
    ).toString();
    // console.log('cryptoInfo: ', cryptoInfo);

    window.SessionStorage.setItem(key, cryptoInfo);
  } else {
    window.SessionStorage.setItem(key, value);
  }
};

const getSessionStorage = (key) => {
  const value = window.SessionStorage.getItem(key);

  if (
    typeof value === 'string' &&
    !['loginProgress', 'hasAuth'].includes(key)
  ) {
    // console.log('value: ', value, key);
    const decrypted = CryptoJS.AES.decrypt(value, aesKey).toString(
      CryptoJS.enc.Utf8,
    );
    // console.log('decrypted: ', decrypted);
    return JSON.parse(decrypted).value;
  }
  return value;
};

export { setSessionStorage, getSessionStorage };
